import { render } from "./RotateRight.vue?vue&type=template&id=a1f8151e"
import script from "./RotateRight.vue?vue&type=script&lang=js"
export * from "./RotateRight.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__